import React from 'react';
import { Link } from 'react-router-dom';
import { Award, Scale, Heart, Users } from 'lucide-react';
import { attorney } from '../mock';

const FirmEs = () => {
  return (
    <div style={{ marginTop: '70px' }}>
      <section style={{
        background: 'var(--bg-card)',
        padding: '80px 0',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="heading-1" style={{ color: 'var(--brand-primary)', marginBottom: '24px' }}>
            Acerca de LG Law Office
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Un nombre de confianza en leyes de lesiones personales, dedicado a luchar por la justicia y máxima compensación para nuestros clientes
          </p>
        </div>
      </section>

      <section style={{ padding: '96px 0', background: 'var(--bg-page)' }}>
        <div className="container">
          <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
            <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '32px' }}>
              Nuestra Misión
            </h2>
            <p className="body-large" style={{ color: 'var(--text-white)', lineHeight: '1.8', marginBottom: '48px' }}>
              En LG Law Office, nuestra misión es simple: proporcionar representación legal excepcional a víctimas de lesiones en toda California. Creemos que todos merecen acceso a asesoría legal de calidad, sin importar su situación financiera. Por eso trabajamos con honorarios de contingencia: usted no paga a menos que ganemos su caso.
            </p>
            <p className="body-large" style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
              Entendemos que sufrir una lesión puede ser uno de los momentos más difíciles de su vida. Las facturas médicas se acumulan, puede que no pueda trabajar, y las compañías de seguros intentan minimizar su reclamo. Nuestro equipo legal experimentado lucha agresivamente para asegurar que reciba la compensación que merece, permitiéndole concentrarse en su recuperación mientras nosotros manejamos las complejidades legales.
            </p>
          </div>
        </div>
      </section>

      <section style={{ padding: '96px 0', background: 'var(--bg-card)' }}>
        <div className="container">
          <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '64px', textAlign: 'center' }}>
            Nuestros Valores Fundamentales
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '48px' }}>
            {[
              { icon: Scale, title: 'Justicia', description: 'Creemos en luchar por lo correcto y responsabilizar a las partes negligentes por sus acciones.' },
              { icon: Heart, title: 'Compasión', description: 'Tratamos a cada cliente con empatía y comprensión, reconociendo el costo personal de las lesiones.' },
              { icon: Award, title: 'Excelencia', description: 'Mantenemos los más altos estándares de representación legal y nos esforzamos por resultados sobresalientes.' },
              { icon: Users, title: 'Compromiso', description: 'Estamos dedicados al éxito de nuestros clientes y brindamos atención personalizada a cada caso.' }
            ].map((value, index) => {
              const IconComponent = value.icon;
              return (
                <div key={index} style={{ textAlign: 'center', padding: '32px', animation: `fadeIn 0.6s ease-out ${index * 0.1}s backwards` }}>
                  <div style={{ width: '80px', height: '80px', background: 'var(--brand-primary)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                    <IconComponent size={40} color="var(--text-inverse)" />
                  </div>
                  <h3 className="heading-4" style={{ color: 'var(--text-white)', marginBottom: '16px' }}>
                    {value.title}
                  </h3>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section style={{ padding: '96px 0', background: 'var(--bg-page)' }}>
        <div className="container">
          <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '64px', textAlign: 'center' }}>
            Conozca a Nuestro Abogado
          </h2>
          <div className="responsive-grid-contact" style={{ alignItems: 'center', maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ position: 'relative', borderRadius: '16px', overflow: 'hidden', border: '3px solid var(--brand-primary)' }}>
              <img src={attorney.image} alt={attorney.fullName} style={{ width: '100%', height: '500px', objectFit: 'cover', display: 'block' }} />
            </div>
            <div>
              <h3 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '8px' }}>
                {attorney.name}
              </h3>
              <p style={{ color: 'var(--text-secondary)', fontSize: '1.25rem', marginBottom: '32px' }}>
                {attorney.title}
              </p>
              <p className="body-medium" style={{ color: 'var(--text-white)', lineHeight: '1.8', marginBottom: '32px' }}>
                Lionel Girón es un abogado de lesiones personales dedicado con años de experiencia luchando por los derechos de víctimas de lesiones en California. Con un historial comprobado de resultados exitosos, el Sr. Girón está comprometido a proporcionar atención personalizada y representación agresiva a cada cliente. Su experiencia abarca compensación laboral, accidentes automovilísticos, lesiones por resbalones y caídas, y accidentes de viajes compartidos. El Sr. Girón cree que todos merecen acceso a representación legal de calidad.
              </p>
              <div style={{ background: 'var(--bg-card)', padding: '32px', borderRadius: '12px', border: '1px solid var(--border-light)' }}>
                <h4 className="heading-5" style={{ color: 'var(--brand-primary)', marginBottom: '20px' }}>
                  Credenciales y Membresías
                </h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ color: 'var(--text-white)', padding: '12px 0', borderBottom: '1px solid var(--border-light)', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <span style={{ color: 'var(--brand-primary)', fontSize: '1.2rem' }}>•</span>
                    <span>Abogado Licenciado por el Colegio de Abogados del Estado de California</span>
                  </li>
                  <li style={{ color: 'var(--text-white)', padding: '12px 0', borderBottom: '1px solid var(--border-light)', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <span style={{ color: 'var(--brand-primary)', fontSize: '1.2rem' }}>•</span>
                    <span>Miembro de la Asociación de Abogados Laborales de California</span>
                  </li>
                  <li style={{ color: 'var(--text-white)', padding: '12px 0', borderBottom: '1px solid var(--border-light)', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <span style={{ color: 'var(--brand-primary)', fontSize: '1.2rem' }}>•</span>
                    <span>Especializado en Leyes de Lesiones Personales</span>
                  </li>
                  <li style={{ color: 'var(--text-white)', padding: '12px 0', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <span style={{ color: 'var(--brand-primary)', fontSize: '1.2rem' }}>•</span>
                    <span>Fluido en Inglés y Español</span>
                  </li>
                </ul>
              </div>
              <Link to="/es/consulta-gratuita" className="btn-primary" style={{ marginTop: '32px', display: 'inline-flex' }}>
                Agendar una Consulta
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: '96px 0', background: 'var(--bg-card)' }}>
        <div className="container">
          <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '48px', textAlign: 'center' }}>
              Nuestro Enfoque
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
              {[
                { step: '01', title: 'Consulta Gratuita', description: 'Comenzamos con una consulta gratuita sin obligación para entender su caso y explicar sus opciones legales.' },
                { step: '02', title: 'Investigación', description: 'Nuestro equipo investiga exhaustivamente su caso, reuniendo evidencia, entrevistando testigos y consultando con expertos.' },
                { step: '03', title: 'Negociación', description: 'Negociamos agresivamente con las compañías de seguros para asegurar el máximo acuerdo para sus lesiones.' },
                { step: '04', title: 'Litigio', description: 'Si es necesario, estamos preparados para llevar su caso a juicio y luchar por sus derechos en la corte.' }
              ].map((item, index) => (
                <div key={index} style={{ display: 'flex', gap: '32px', alignItems: 'flex-start', padding: '32px', background: 'var(--bg-page)', borderRadius: '12px', border: '1px solid var(--border-light)', animation: `fadeIn 0.6s ease-out ${index * 0.1}s backwards` }}>
                  <div style={{ fontSize: '3rem', fontWeight: '900', color: 'var(--brand-primary)', lineHeight: '1', minWidth: '80px' }}>
                    {item.step}
                  </div>
                  <div>
                    <h3 className="heading-4" style={{ color: 'var(--text-white)', marginBottom: '12px' }}>
                      {item.title}
                    </h3>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FirmEs;